import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { useState } from "react";
import { AsyncFeedbackProvider } from "@/shared/feedback/AsyncFeedbackProvider";
import { ConfirmDeleteHost } from "@/shared/feedback/ConfirmDeleteHost";

export function AppProviders({ children }: { children: ReactNode }) {
  const [client] = useState(() => new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } }));
  return (
    <QueryClientProvider client={client}>
      <AsyncFeedbackProvider>
        {children}
        <ConfirmDeleteHost />
      </AsyncFeedbackProvider>
    </QueryClientProvider>
  );
}
